import React, {FC} from 'react';
import './style.scss';
import MixesList from "../../MixesList";
import {IMix} from "../../../constants/types";

interface IForYou {
    tobacco: Array<IMix>,
    setIndex: any
}

const ForYou: FC<IForYou> = ({tobacco, setIndex}) => {
    return (
        <div className="for-you">
            <MixesList
                mixes={tobacco}
                setTobaccoIndex={setIndex}
                pathUrl="/main/for-you/"
            />
        </div>
    )
};

export default ForYou;
